import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import * as types from "@/store/constants/types";
import { getLang } from '../../api/utils/apiHelper';

var YearSpec =
/*#__PURE__*/
function (_Vue) {
  _inherits(YearSpec, _Vue);

  function YearSpec() {
    _classCallCheck(this, YearSpec);

    return _possibleConstructorReturn(this, _getPrototypeOf(YearSpec).apply(this, arguments));
  }

  _createClass(YearSpec, [{
    key: "isFrench",
    get: function get() {
      return getLang() === "fr";
    }
  }, {
    key: "isEspanish",
    get: function get() {
      return getLang() === "es";
    }
  }]);

  return YearSpec;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], YearSpec.prototype, "routerPush", void 0);

tslib_1.__decorate([Getter(types.GETTER_HOROSCOPE)], YearSpec.prototype, "horoScope", void 0);

tslib_1.__decorate([Getter(types.GETTER_TODAY_HOROSCOPE_FATE)], YearSpec.prototype, "todayHorosopeFate", void 0);

tslib_1.__decorate([Prop()], YearSpec.prototype, "specData", void 0);

YearSpec = tslib_1.__decorate([Component({
  components: {}
})], YearSpec);
export default YearSpec;